/**
 * Method for handling nulls for sort.
 * If either or both inputs are null, compare and return appropriate value.
 * Return null otherwise
 *
 * @param {*} a
 * @param {*} b
 */
export function handleNulls (a, b) {
  // check if null => null, undefined, empty {}, 0, bool false
  if ((!a && a !== 0 && a !== false) || (!b && b !== 0 && b !== false)) {
    // pushed null values to last
    // both are null is equivalent to equal
    if (!a && a !== 0 && a !== false && !b && b !== 0 && b !== false) {
      return 0
    } else if (!a && a !== 0 && a !== false) {
      return 1
    } else if (!b && b !== 0 && b !== false) {
      return -1
    }
  }
  return null
}



// WEBPACK FOOTER //
// ./src/utilities/sort.helper.js